import { render } from "./foot.vue?vue&type=template&id=854ffec8&scoped=true"
const script = {}

import "./foot.vue?vue&type=style&index=0&id=854ffec8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.2.39_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-854ffec8"]])

export default __exports__